import { graphql, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import React from "react"
import Sticky from "react-sticky-el"
import { Container } from "reactstrap"
import Layout from "../components/layout"
import Search from "../components/search/search"
import Seo from "../components/seo"
import Devlogo from "../images/logo2-90x90.png"
import { FaLinkedin } from "react-icons/fa"

import marked from "marked"

// const authorBio = author?.authorbio || "Author bio coming soon."

import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share"
import "./category.css"

const slugify = require("slugify")
class AuthorTemplate extends React.Component {
  render() {
    const { data, pageContext } = this.props
    const { title } = pageContext
    const posts = data.allSanityPost.edges
    const knowledgeBase = data?.allSanityKnowledgeBase.edges
    const author = data.sanityAuthor
    // Filter posts by author name.
    const authorPosts = posts.filter(({ node }) => node.author.name === title)

    const authorKnowledgeBase = knowledgeBase.filter(
      ({ node }) => node.author.name === title
    )

    return (
      <Layout location={this.props.location}>
        <Seo
          title={`${title} Archives - Quandary Consulting Group`}
          description="description"
        />
        <div className="page-content mt-4">
          <section className="category-section component">
            <Container>
              <div className="row">
                <div className="col-md-12 pb-5">
                  <div className="row sm:align-items-center flex-column-reverse flex-lg-row x-">
                    <div className="col-lg-4 mt-lg-0 mt-md-0 mt-3 sm:align-self-center pb-lg-0 pb-5">
                      <div className="quandary-team-image">
                        {author?.image?.asset?.gatsbyImageData ? (
                          <GatsbyImage
                            style={{ width: "300px", height: "350px" }}
                            image={author?.image.asset.gatsbyImageData}
                            alt={author?.name}
                            imgClassName="author"
                          />
                        ) : (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              height: "256px",
                              width: "270px",
                              backgroundColor: "#f7f2f2",
                            }}
                          >
                            <svg width="208" height="208" viewBox="0 0 480 480">
                              <path
                                fill="currentColor"
                                d="M240 0C107.664 0 0 107.664 0 240c0 57.96 20.656 111.184 54.992 152.704.088.12.096.272.192.384 24.792 29.896 55.928 52.816 90.624 67.624.4.168.792.352 1.192.52 2.808 1.184 5.648 2.28 8.496 3.352 1.12.424 2.24.856 3.376 1.264 2.456.88 4.928 1.712 7.416 2.512 1.592.512 3.184 1.016 4.792 1.496 2.2.656 4.408 1.288 6.632 1.888 1.952.528 3.92 1.016 5.888 1.488 1.992.48 3.992.96 6 1.384 2.24.48 4.504.904 6.776 1.32 1.824.336 3.64.688 5.48.984 2.52.408 5.056.728 7.6 1.056 1.64.208 3.272.448 4.92.624 2.88.304 5.784.52 8.696.72 1.352.096 2.696.24 4.056.312 4.248.24 8.544.368 12.872.368s8.624-.128 12.888-.352c1.36-.072 2.704-.216 4.056-.312 2.912-.208 5.816-.416 8.696-.72 1.648-.176 3.28-.416 4.92-.624 2.544-.328 5.08-.648 7.6-1.056 1.832-.296 3.656-.648 5.48-.984 2.264-.416 4.528-.84 6.776-1.32 2.008-.432 4-.904 6-1.384 1.968-.48 3.936-.968 5.888-1.488a232.661 232.661 0 0011.424-3.384c2.488-.8 4.96-1.632 7.416-2.512 1.128-.408 2.248-.84 3.376-1.264a243.168 243.168 0 008.496-3.352c.4-.168.792-.352 1.192-.52a239.997 239.997 0 0090.624-67.624c.096-.112.104-.272.192-.384C459.344 351.184 480 297.96 480 240 480 107.664 372.336 0 240 0zm97.256 441.76c-.12.056-.232.12-.352.176-2.856 1.376-5.76 2.672-8.688 3.936-.664.28-1.32.568-1.984.848a217.023 217.023 0 01-7.76 3.064 159.85 159.85 0 01-3.272 1.192 230.572 230.572 0 01-6.976 2.368c-1.456.464-2.92.904-4.384 1.336a202.08 202.08 0 01-6.28 1.784c-1.776.472-3.568.904-5.36 1.328-1.88.448-3.752.904-5.648 1.304-2.072.44-4.16.816-6.24 1.192-1.688.312-3.368.64-5.072.912-2.344.368-4.712.664-7.072.96-1.496.192-2.984.416-4.496.576-2.696.288-5.416.472-8.128.664-1.208.08-2.408.216-3.632.28-3.96.208-7.928.32-11.912.32s-7.952-.112-11.904-.32c-1.216-.064-2.416-.192-3.632-.28-2.72-.184-5.432-.376-8.128-.664-1.512-.16-3-.384-4.496-.576-2.36-.296-4.728-.592-7.072-.96-1.704-.272-3.384-.6-5.072-.912-2.088-.376-4.176-.76-6.24-1.192-1.896-.4-3.776-.856-5.648-1.304-1.792-.432-3.584-.856-5.36-1.328-2.104-.56-4.2-1.168-6.28-1.784a212.543 212.543 0 01-4.384-1.336 223.256 223.256 0 01-6.976-2.368 217.023 217.023 0 01-11.032-4.256c-.664-.272-1.312-.56-1.976-.84a223.812 223.812 0 01-8.696-3.936 7.216 7.216 0 01-.352-.176c-27.912-13.504-52.568-32.672-72.576-55.952 15.464-56.944 59.24-102.848 115.56-121.112 1.112.68 2.272 1.288 3.416 1.928.672.376 1.336.776 2.016 1.136a99.592 99.592 0 007.272 3.512c1.896.832 3.856 1.536 5.808 2.256.384.136.768.288 1.152.424 10.848 3.84 22.456 6.04 34.6 6.04s23.752-2.2 34.592-6.04c.384-.136.768-.288 1.152-.424 1.952-.72 3.912-1.424 5.808-2.256a99.592 99.592 0 007.272-3.512c.68-.368 1.344-.76 2.016-1.136 1.144-.64 2.312-1.248 3.432-1.936 56.32 18.272 100.088 64.176 115.56 121.112-20.008 23.272-44.664 42.44-72.576 55.952zM152 176c0-48.52 39.48-88 88-88s88 39.48 88 88c0 30.864-16.008 58.024-40.128 73.736a84.742 84.742 0 01-9.8 5.48c-.4.192-.792.392-1.192.576-23.168 10.536-50.592 10.536-73.76 0-.4-.184-.8-.384-1.192-.576a84.083 84.083 0 01-9.8-5.48C168.008 234.024 152 206.864 152 176zm269.832 194.584c-18.136-53.552-59.512-96.832-112.376-117.392C330.6 234.144 344 206.64 344 176c0-57.344-46.656-104-104-104s-104 46.656-104 104c0 30.64 13.4 58.144 34.552 77.192-52.864 20.568-94.24 63.84-112.376 117.392C31.672 333.792 16 288.704 16 240 16 116.488 116.488 16 240 16s224 100.488 224 224c0 48.704-15.672 93.792-42.168 130.584z"
                              ></path>
                            </svg>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-8 mx-auto">
                      {author?.name && (
                        <p
                          className="h3 mb-0 pb-1 d-flex align-items-center"
                          style={{ color: "#00b5f4" }}
                        >
                          {author?.name}
                          {author?.linkedin && (
                            <a
                              href={author?.linkedin}
                              target="_blank"
                              rel="noreferrer"
                              className="d-flex align-items-center ml-2"
                              style={{
                                position: "relative",
                                zIndex: "1",
                                marginLeft: "0.5rem",
                              }}
                            >
                              <span
                                style={{
                                  background: "#fff",
                                  borderRadius: "0.2rem",
                                }}
                              >
                                <FaLinkedin
                                  color="#0D65A6"
                                  style={{ height: "2em", width: "1.2em" }}
                                />
                              </span>
                            </a>
                          )}
                        </p>
                      )}
                      {author?.position && (
                        <p className="mb-0 pb-0" style={{ color: "#7B7B7B" }}>
                          {author?.position}
                        </p>
                      )}
                      {author?.email ? (
                        <>
                          <a aria-label="link" href={`mailto:${author.email}`}>
                            {author?.email}
                          </a>
                        </>
                      ) : (
                        "No Email available yet"
                      )}

                      <div
                        className="mb-0 pt-4 pb-5 bio-text"
                        dangerouslySetInnerHTML={{
                          __html: marked(
                            author?.authorbio || "Author bio coming soon."
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="pb-20">
                    <div className="justify-content-between align-items-stretch h-100">
                      <div className="mb-4">
                        <div className="knowledge-section h-100">
                          <p className="h3 font-weight-medium mt-0">
                            Knowledge Base Articles
                          </p>

                          {authorKnowledgeBase?.length > 0 ? (
                            authorKnowledgeBase?.map((knowledge, index) => {
                              return (
                                <div key={index}>
                                  <ul className="knowledge-section-list list-unstyled m-0">
                                    <li className="knowledge-post-link">
                                      <span
                                        aria-hidden="true"
                                        className="knowledge-heading-icon fa fa-file-text-o mt-1 mr-2"
                                      />
                                      <Link
                                        to={`/knowledge-base/${knowledge.node.categories[0]?.slug?.current}/${knowledge?.node?.slug?.current}/`}
                                        data-wpel-link="internal"
                                      >
                                        {knowledge?.node?.title}
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              )
                            })
                          ) : (
                            <p className="font-weight-medium mt-0">
                              Author doesn't have any knowledge base articles
                              yet.
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pt-5">
                {/* <div className="col-lg-3 col-md-12 col-sm-12">
                  <Search />
                  <div className="recent-post">
                    <h5 className="font-weight-medium mt-0">Recent Posts</h5>
                    <ul className="list-unstyled pt-3">
                      {data.allSanityPost.edges.slice(0, 4).map(({ node }) => {
                        return (
                          <li>
                            <p className="text-teal font-weight-bold mb-1">
                              {node.publishedAt
                                ? node.publishedAt
                                : node._createdAt}
                            </p>
                            <Link
                              className="text-secondary font-weight-medium"
                              to={`/${node.slug.current}/`}
                            >
                              {node.title}
                            </Link>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div> */}
                <div className="col-lg-12 pl-5">
                  <div className="author-bio blog-content-wrapper">
                    <div className="category-content"></div>
                  </div>
                  <div className="container">
                    <div className="blog-content-wrapper">
                      <Sticky
                        className="sticky-wrapper"
                        stickyClassName="is-sticky"
                        stickyStyle={{ transform: "unset", zIndex: "9999" }}
                        boundaryElement=".blog-content-wrapper"
                      >
                        <ul className="social-media list-unstyled">
                          <li className="mb-2">
                            <FacebookShareButton url="https://quandarycg.com/will-there-be-a-threat-from-automation/">
                              <FacebookIcon size={40} borderRadius={5} />
                            </FacebookShareButton>
                          </li>
                          <li className="mb-2">
                            <TwitterShareButton url="https://quandarycg.com/will-there-be-a-threat-from-automation/">
                              <TwitterIcon size={40} borderRadius={5} />
                            </TwitterShareButton>
                          </li>
                          <li className="mb-2">
                            <LinkedinShareButton
                              url="https://quandarycg.com/will-there-be-a-threat-from-automation/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <LinkedinIcon size={40} borderRadius={5} />
                            </LinkedinShareButton>
                          </li>
                        </ul>
                      </Sticky>
                      <div className="category-lists row">
                        {authorPosts.length === 0 ? (
                          <p>Author doesnt have any blog posts yet.</p>
                        ) : (
                          authorPosts.map(blog => {
                            const BlogImg = getImage(
                              blog.node.mainImage !== null
                                ? blog.node.mainImage.asset.gatsbyImageData
                                : "https://source.unsplash.com/user/joshhild/500x500"
                            )
                            const BlogBgImg = convertToBgImage(BlogImg)
                            return (
                              <div className="col-lg-6">
                                <article
                                  className="category-list-item"
                                  key={blog.node.id}
                                >
                                  <div className="category-featured">
                                    <BackgroundImage
                                      Tag="div"
                                      className="post-image"
                                      {...BlogBgImg}
                                      preserveStackingContext
                                    >
                                      <Link
                                        to={`/${blog.node.slug.current}/`}
                                        className
                                      ></Link>
                                    </BackgroundImage>
                                    <div className="category-meta">
                                      <div className="category-author-holder">
                                        <div className="category-author-name">
                                          <span>by&nbsp;</span>
                                          <Link
                                            to={`/author/${slugify(
                                              blog.node.author
                                                ? blog.node.author.name.toLowerCase() +
                                                    "/"
                                                : "/"
                                            )}`}
                                            title={`Posts by ${
                                              blog.node.author
                                                ? blog.node.author.name
                                                : ""
                                            }`}
                                            rel="author"
                                          >
                                            {blog.node.author
                                              ? blog.node.author.name
                                              : ""}
                                          </Link>
                                        </div>
                                        <div className="item-date mt-1">
                                          {blog.node.publishedAt
                                            ? blog.node.publishedAt
                                            : blog.node._createdAt}
                                        </div>
                                        <p>
                                          {blog.node.author
                                            ? blog.node.author.bio
                                            : ""}
                                        </p>
                                      </div>
                                      <div className="category-author-image">
                                        <GatsbyImage
                                          style={{
                                            width: 43,
                                            height: 43,
                                          }}
                                          image={
                                            blog.node.author
                                              ? blog.node.author.image.asset
                                                  .gatsbyImageData
                                              : Devlogo
                                          }
                                          alt={
                                            blog.node.author
                                              ? blog.node.author.name
                                              : "Dev Team"
                                          }
                                          imgClassName="author"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="category-holder">
                                    <div className="category-category w-100">
                                      {blog.node.categories &&
                                      blog.node.categories.length !== 0
                                        ? blog.node.categories.map(
                                            (ct, idx) => {
                                              const slug = slugify(
                                                ct.title.toLowerCase()
                                              )
                                              return (
                                                <Link
                                                  className="text-small font-weight-medium text-uppercase"
                                                  to={`/category/${slug}/`}
                                                  key={ct.title}
                                                >
                                                  {(idx ? ", " : "") + ct.title}
                                                </Link>
                                              )
                                            }
                                          )
                                        : null}
                                    </div>
                                    <h4 className="category-title mt-2">
                                      <Link
                                        aria-label="link"
                                        to={`/${blog.node.slug.current}/`}
                                      >
                                        {blog.node.title}
                                      </Link>
                                    </h4>
                                    <div className="category-content">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            blog.node.body
                                              .slice(0, 180)
                                              .replace(/#/g, "") + "...",
                                        }}
                                      />
                                    </div>
                                    <div className="category-more">
                                      <Link
                                        className="font-weight-medium"
                                        to={`/${blog.node.slug.current}/`}
                                      >
                                        Read Now <i className="item-arrow" />
                                      </Link>
                                    </div>
                                  </div>
                                </article>
                              </div>
                            )
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-4">

                </div> */}
              </div>
            </Container>
          </section>
        </div>
      </Layout>
    )
  }
}
export default AuthorTemplate

export const authorQuery = graphql`
  query authorQuery($id: String!) {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
    sanityPost(id: { eq: $id }) {
      id
      author {
        id
        name
      }
    }
    sanityAuthor(id: { eq: $id }) {
      id
      name
      email
      position
      authorbio
      linkedin
      image {
        asset {
          gatsbyImageData(
            fit: FILL
            placeholder: BLURRED
            sizes: ""
            layout: CONSTRAINED
          )
        }
      }
    }
    allSanityPost(sort: { order: ASC, fields: publishedAt }) {
      edges {
        node {
          id
          title
          publishedAt(formatString: "MMMM DD, YYYY")
          _createdAt(formatString: "MMMM DD, YYYY")
          mainImage {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          author {
            id
            name
            image {
              asset {
                _id
                gatsbyImageData(
                  fit: FILL
                  placeholder: BLURRED
                  sizes: ""
                  layout: CONSTRAINED
                )
              }
            }
          }
          slug {
            current
          }
          body
          categories {
            title
          }
        }
      }
    }
    allSanityKnowledgeBase {
      edges {
        node {
          id
          title
          author {
            name
          }
          categories {
            ... on SanityKnowledgebasecategory {
              id
              title
              slug {
                current
              }
              _id
            }
            ... on SanitySubCategory {
              id
              title
              slug {
                current
              }
            }
          }
          slug {
            current
          }
        }
      }
    }
  }
`
